import BaseModalView from "scripts/views/baseModalView";
import templateFacetedSearchTermModal from "templates/search/facetedSearchTermModal.hbs";

class FacetedSearchTermModalView extends BaseModalView {
  constructor(options) {
    super(options);

    this.searchTerm = options.searchTerm;
  }

  get events() {
    return {
      "click #bb-faceted-search-facet-modal-apply-button": "onClickApply",
      "click #bb-faceted-search-facet-modal-clear-input": "onClear",
      "keydown input": "onSubmit",
    };
  }

  get className() {
    return "modal-content faceted-search-modal";
  }

  get template() {
    return templateFacetedSearchTermModal;
  }

  render() {
    this.$el.html(
      this.template({
        searchTerm: this.searchTerm,
      }),
    );

    return this;
  }

  onClickApply() {
    this.searchTerm = this.$el.find("input").val();
    this.trigger("apply", this.searchTerm);
  }

  onClear(e) {
    e.preventDefault();
    const search = this.$el.find("input");
    search.val("");
    search.focus();
  }

  onSubmit(e) {
    if (e.key === "Enter") {
      e.preventDefault();
      this.onClickApply();
      this.closeModal();
    }
  }
}

export default FacetedSearchTermModalView;
